import React from 'react';

const SignUp = () => {
  return <h1>Sign Up</h1>;
}
export default SignUp;